import {SET_CURRENT_USER, SET_USER_TOKEN, SET_HAS_MEMBERSHIP_ACCESS} from '@/store/mutationTypes'
import {account} from '@/api'
import {handleError, prepareResponse, requestFinished} from '@/store/utils'
import Vue from "vue";
import {inviteCodesToUri} from "../../utils";


const fgdebug = () => {
  const tokenInCookie = Vue.$cookies.get(process.env.FG_AUTH_COOKIE_TOKEN);
  const userInCookie = Vue.$cookies.get(process.env.FG_AUTH_COOKIE_USER);
  console.log("Token cookie: ", tokenInCookie)
  console.log("User cookie: ", userInCookie)
}

window.fgdebug = fgdebug;

const saveSession = (commit, {user, token}) => {
  // commit(SET_CURRENT_USER, user)
  commit(SET_USER_TOKEN, token)

  Vue.$cookies.set(process.env.FG_AUTH_COOKIE_TOKEN, token, 0);
  setUser(commit, {user})
}

const setUser = (commit, {user}) => {
  // take only selected user fields
  const minimalUser = (({ id, firstName, lastName, email, phone }) =>
    ({ id, firstName, lastName, email, phone }))(user);

  commit(SET_CURRENT_USER, user)
  // console.log("Setting", minimalUser);
  Vue.$cookies.set(process.env.FG_AUTH_COOKIE_USER, minimalUser, 0);
}

function doLogout(commit) {
  commit(SET_CURRENT_USER, null)
  commit(SET_USER_TOKEN, null)
  commit(SET_HAS_MEMBERSHIP_ACCESS, null)
  Vue.$cookies.remove(process.env.FG_AUTH_COOKIE_TOKEN);
  Vue.$cookies.remove(process.env.FG_AUTH_COOKIE_USER);
}

export default {
  actions: {
    login({dispatch, commit}, loginData) {
      prepareResponse(commit)

      return account.login(loginData.email, loginData.password)
        .then((response) => {
          saveSession(commit, response.login);
          dispatch('recordMembershipScan');
          requestFinished(commit)
        }, (error) => {
          handleError(commit, error)
        })
        .catch(error =>
          handleError(commit, error)
        )
    },

    loginViaToken({commit}, {token, userId}) {

      doLogout(commit);

      prepareResponse(commit)
      return account.get(userId, token)
        .then(response => {
          const {user} = response;
          saveSession(commit, {user, token});
          requestFinished(commit)
        }, err => {
          handleError(commit, err)
        })
        .catch(err => {
          handleError(commit, err)
        })
    },

    resetPassword({commit}, resetData) {
      prepareResponse(commit)

      const {inviteCodes, email, redirect} = resetData;
      let resetUrl = process.env.PUBLIC_PATH + 'signup/update-password';
      if (inviteCodes!=null && inviteCodes.length>0) {
        resetUrl += `/invite/${inviteCodesToUri(inviteCodes)}`
      }
      if (redirect!=null && redirect.length>0) {
        const searchParams = new URLSearchParams()
        searchParams.set('redirect', redirect)
        resetUrl += `?${searchParams.toString()}`
      }
      return account.resetPassword(email, resetUrl)
        .then((response) => {
          if (response && response.resetPassword) {
            if (response.resetPassword.success) {
              requestFinished(commit)
            } else {
              handleError(commit, response.resetPassword.errorMessage)
            }
          } else {
            handleError(commit, response)
          }
        }, (error) => {
          handleError(commit, error)
        })
        .catch(error =>
          handleError(commit, error)
        )
    },

    recoverPassword({commit}, loginData) {
      prepareResponse(commit)

      return account.recoverPassword(loginData.password, loginData.token)
        .then((response) => {
          if (response && response.recoverPassword) {
            if (response.recoverPassword.success) {
              requestFinished(commit)
            } else {
              handleError(commit, response.recoverPassword.errorMessage)
            }
          } else {
            handleError(commit, response)
          }
        }, (error) => {
          handleError(commit, error)
        })
        .catch(error =>
          handleError(commit, error)
        )
    },

    logout({commit}) {
      doLogout(commit)
    },


    loadCurrentUser({dispatch, commit, getters}) {
      if (!getters.currentUser || !getters.userToken) {
        return
      }
      return account.get(getters.currentUser.id, getters.userToken)
        .then(response => {
          setUser(commit, response);

          if (getters.membershipScanPending) {
            dispatch('membershipScanRecorded');
            if (response.user && response.user.membership && response.user.membership.plasticCard) {
              dispatch('checkTicket', {
                code: response.user.membership.plasticCard.code,
                time: null,
              })
            }
          }

        }, err => {
          handleError(commit, err)
        })
        .catch(err => {
          handleError(commit, err)
        })
    },

    // NOT USED
    sendWelcomeEmail({getters}) {
      return account.sendEmailConfirmation(getters.currentUser.email)
        .then(() => {
          // console.log(resp)
        }, err => {
          console.warn(err)
        })
    },

    signUp({commit}, accountData) {
      prepareResponse(commit)
      return account.create(accountData)
        .then(response => {
          requestFinished(commit)
          saveSession(commit, response.register);
        }, err => {
          handleError(commit, err)
        })
        .catch(err => {
          handleError(commit, err)
        })
    },

    signUpEmail({commit}, data) {
      prepareResponse(commit)
      return account.signUpEmail(data)
        .then(() => {
          requestFinished(commit)
        }, err => {
          handleError(commit, err)
        })
        .catch(err => {
          handleError(commit, err)
        })
    },

    updateUser({commit, getters}, newAccountData) {
      prepareResponse(commit)
      return account.update(getters.currentUser.id, newAccountData, getters.userToken)
        .then(response => {
          requestFinished(commit)
          setUser(commit, {user: response.updateUser})
        }, err => {
          return handleError(commit, err)
        })
        .catch(err => {
          return handleError(commit, err)
        })
    },

    getUserPayments({commit, getters}) {
      prepareResponse(commit)
      return account.getPayments(getters.currentUser.id, getters.userToken)
        .then(response => {
            requestFinished(commit)
            return Promise.resolve(response.user)
          },
          err => {
            handleError(commit, err)
            return Promise.reject(err)
          })
        .catch(err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
    }
  }
}